import { createSlice } from "@reduxjs/toolkit";

export const venueImageSlice = createSlice({
  name: "venueImage",
  initialState: {
    getImagesLoading: false,
    getImagesError: false,
    getImagesData: null,
    imagesLoading: false,
    imagesError: false,
    imagesStatusCode: 0,
    imagesMessage: "",
    singleImageLoading: false,
    singleImageError: false,
    singleImageId: null,
    singleImageType: null,
    singleImageGalleryIndex: null,
    singleImageIsDelete: false,
  },
  reducers: {
    onGetImages: (state) => ({
      ...state,
      getImagesLoading: true,
      getImagesError: false,
      getImagesData: null,
    }),
    onGetImagesSuccess: (state, { payload }) => {
      const { data = null } = payload ?? {};
      const images = Array.isArray(data)
        ? data
        : (data?.images ?? data?.data ?? []);
      return {
        ...state,
        getImagesLoading: false,
        getImagesError: false,
        getImagesData: images,
      };
    },
    onGetImagesError: (state) => ({
      ...state,
      getImagesLoading: false,
      getImagesError: true,
      getImagesData: null,
    }),
    onVenueImagesUpload: (state) => ({
      ...state,
      imagesLoading: true,
      imagesError: false,
      imagesStatusCode: 0,
      imagesMessage: "",
    }),
    onVenueImagesUploadSuccess: (state, { payload }) => {
      const { status_code = 200, message = "" } = payload;
      return {
        ...state,
        imagesLoading: false,
        imagesError: false,
        imagesStatusCode: status_code,
        imagesMessage: message,
      };
    },
    onVenueImagesUploadError: (state, { payload }) => {
      const { status_code = 400, message = "" } = payload;
      return {
        ...state,
        imagesLoading: false,
        imagesError: true,
        imagesStatusCode: status_code,
        imagesMessage: message,
      };
    },
    onVenueImagesUploadReset: (state) => ({
      ...state,
      imagesLoading: false,
      imagesError: false,
      imagesStatusCode: 0,
      imagesMessage: "",
    }),
    onVenueSingleImageUpload: (state, { payload }) => {
      const { type = null, galleryIndex = null, isDeleted = false } = payload ?? {};
      return {
        ...state,
        singleImageLoading: true,
        singleImageError: false,
        singleImageId: null,
        singleImageType: type,
        singleImageGalleryIndex: galleryIndex,
        singleImageIsDelete: isDeleted === true,
      };
    },
    onVenueSingleImageUploadSuccess: (state, { payload }) => {
      const { id, type, galleryIndex } = payload ?? {};
      return {
        ...state,
        singleImageLoading: false,
        singleImageError: false,
        singleImageId: id ?? null,
        singleImageType: type ?? null,
        singleImageGalleryIndex: galleryIndex ?? null,
        singleImageIsDelete: false,
      };
    },
    onVenueSingleImageUploadError: (state) => ({
      ...state,
      singleImageLoading: false,
      singleImageError: true,
      singleImageId: null,
      singleImageType: null,
      singleImageGalleryIndex: null,
      singleImageIsDelete: false,
    }),
    onVenueSingleImageUploadReset: (state) => ({
      ...state,
      singleImageLoading: false,
      singleImageError: false,
      singleImageId: null,
      singleImageType: null,
      singleImageGalleryIndex: null,
      singleImageIsDelete: false,
    }),
  },
});

export const {
  onGetImages,
  onGetImagesSuccess,
  onGetImagesError,
  onVenueImagesUpload,
  onVenueImagesUploadSuccess,
  onVenueImagesUploadError,
  onVenueImagesUploadReset,
  onVenueSingleImageUpload,
  onVenueSingleImageUploadSuccess,
  onVenueSingleImageUploadError,
  onVenueSingleImageUploadReset,
} = venueImageSlice.actions;

export default venueImageSlice.reducer;
